import React, { useEffect, useState, useContext } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import {
    Button,
    InputLabel,
  } from "@material-ui/core";
  import TextField from '@material-ui/core/TextField';
  import axios from "axios";

  import { BASE_API_URL } from "../../../constants.tsx";
import Tabs from "@material-ui/core/Tabs";
import { useHistory, useLocation } from "react-router";
import Tab from "@material-ui/core/Tab";
import PropTypes from 'prop-types';
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import HeaderMenu from "../../../Components/HeaderMenu";
import BannerImage from "../../../Images/CRFHeader.png";
import Paper from "@material-ui/core/Paper";
import DataService from "../../../Service";
import IconButton from "@material-ui/core/IconButton";
import Select from "@material-ui/core/Select/Select";
import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';
import CustomInput from "../../../Components/CustomInput";
import CustomSelect from "../../../Components/CustomSelect";
import { useParams } from "react-router-dom";
import DataClient from "../../../Service/general_data_service";
import { showSnackbar } from "../../../Components/Snackbar/SnackbarActions";
import MenuItem from '@material-ui/core/MenuItem';
import useScrollTrigger from "@material-ui/core/useScrollTrigger";
import Fab from "@material-ui/core/Fab";
import Zoom from "@material-ui/core/Zoom";
import { useSelector, useDispatch } from "react-redux";
import useHideOnScrolled from "../../../Components/UseHideOnScrolled";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from "@material-ui/core/FormControl";

const AntTabs = withStyles({
  root: {
    borderBottom: "1px solid #e8e8e8",
    textTransform: 'none',

    // justifyContent:'space-around'
  },
  indicator: {
    backgroundColor: "#1890ff",
  },
})(Tabs);



const useStyles = makeStyles((theme) => ({
  root1: {
    position: "fixed",
    bottom: theme.spacing(2),
    right: theme.spacing(10)
  },
  bannerStyle:{
  top: 0,
  left: 0,
  right: 0,
  zIndex: 1301,
  position: "sticky"
  },
  demo1: {
    backgroundColor: theme.palette.background.paper,
    // position: "absolute",
    // top: "41%",
    marginLeft: "11%",
    // marginBottom:'25px',
    width: "80.6%",
    // padding: "5%",
  },
  statsBoard:{
    display:'flex',
    alignItems:'center',
    justifyContent:'space-between',
    padding:theme.spacing(2),
    width:'17%',
    borderLeft: 'solid #3B86FF'
    // borderColor:'#56D9FE'
},
labelText: {
  color: "#4D4F5C",
  fontSize: "16px",
  lineHeight: "22px",
},
  demo2: {
    // backgroundColor: "#2e1534",
    // position: "absolute",
    // top: "38.1%",
    marginLeft: "134px",
    width: "84%",
    marginTop:'-45.5px'
    // padding:'5px'
    // height: "100%",
  },
}));
function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-auto-tabpanel-${index}`}
        aria-labelledby={`scrollable-auto-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3} style={{paddingTop:"30px"}}>
          <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };
  let sectionId = '';
  let crfFromId = ''
  function a11yProps(index,item) {
     sectionId = item.id;
     crfFromId = item.coaching_request_form_id;
    //   setCrfSectionId(item.id)
    //   setCrfFormId(item.coaching_request_form_id)
    return {
      id: `scrollable-auto-tab-${index}`,
      'aria-controls': `scrollable-auto-tabpanel-${index}`,
    };
  }
export default function CustomizedTabs() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const [action, setAction] = useState(null);
  const [modules, setModules] = useState(null);
  const [loading, setLoading] = useState(false);
  const [CoachinRequest, setCrfSection] = useState([]);
  const [crfAnswers, setCrfAnswers] = useState([]);
  const dispatch = useDispatch();
  const sessionStorage = window.sessionStorage.getItem("slug");
  const [submitClickFlag, setSubmitClickFlag] = React.useState(false);
  const [userData, setUserData] = useState();
  const [radioValue, seRadioValue] = useState("");
  const location = useLocation();
  const [orgLogo, setOrgLogo] = useState("");
  const [showCrfList, setShowCrfList] = useState(false);
  const [currentSelectionField, setCurrentSelectionField] = useState({});
  const [currentSelection, setCurrentSelection] = useState({});
  const [CoachinRates, setModuleSetups] = useState([]);
  const [crfValue, setCrfValue] = useState([]);
  const [fieldAction, setFieldAction] = useState(null);
  const [totalCount, setTotalCount] = useState(100);
  const [crfUserId, setCrfUserId] = useState("");
  const [crfFormId, setCrfFormId] = useState("");
  const [crfId, setCrfId] = useState('');
  let { slug } = useParams();
  const [answerData, setAnswerData] = useState({});
  let quesArr = []
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleradioChange = (event) => {
    seRadioValue(event.target.value);
};

const handleUpdate = (formData) => {
  // setValue(event.target.value);
  const statusData={
    service_type: 'External',
    approval_required:radioValue
  }
DataClient.update(statusData,`/coaching_request_forms/${crfId}`)
.then((res) => {
   
  if (res) { 
    setLoading(true); 
    dispatch(showSnackbar("success", ["Success!"]));
    // CoachinRate();
    // handleClose(); 
    // CoachinRate();
  } else {
    
    setSubmitClickFlag(true)
    setLoading(false);
    // dispatch(showSnackbar("error", [["" + err.errors]]));
  }
})


};
  const urlParams =
  typeof window !== `undefined` &&
  new URLSearchParams(window.location.search);

// const EmpID = sessionStorage.getItem("employee_id");
const bodyParameters = {
 key: "value"
};


const globaluserData = useSelector(state => state.commonReducer)
const orgId = globaluserData?.organisation_id;
  // const orgId = localStorage.getItem("organisation_id")
const handleChangeData =(fieldId)=>{
console.log(`fieldId`, fieldId)
}
  const setInputState = (inputStateValue, inputId) => {
    console.log(`object`, inputStateValue,inputId)
    setAnswerData({ ...answerData, [inputId]: inputStateValue });
    setUserData({ ...userData, [inputId]: inputStateValue });
  };
  const setQuestionChangeState = (selectedItemValue, inputId) => {
    setUserData({ ...userData, [selectedItemValue]: selectedItemValue });
    setAnswerData({ ...answerData, [inputId]: selectedItemValue });
    (inputId == "Business Experience") && setUserData({ ...userData, "ref4": selectedItemValue.value })
};

const Programmes = () => {
  const statusData={
    organisation_id:orgId
  }
  DataService.getDirectData(
    `coaching_request_forms_email/listing_programme`,statusData
    
  ).then((res) => {
    setTotalCount(res["total_count"]);
    // if(res.success){
    if (res.programmes && res.programmes.length > 0) {
      let CoachinRates = res.programmes;
      setModuleSetups(CoachinRates);
    }
    setLoading(false);
  });
};
  const CrfFetch = () => {
    DataService.getDirectData(`/coaching_request_forms_email/${slug}`).then(
      (res) => {
        // if(res.success){
    setCrfId(res.coaching_request_form.id)
        let CoachinRequests = res.coaching_request_form.crf_form_sections;
        let orgLogo =  res.coaching_request_form.org_logo
        setOrgLogo(orgLogo)
        setCrfSection(CoachinRequests);
        localStorage.clear();
        // setLoading(false);
      }
    );
  };
  const FetchCrfAnswer = () => {
    const statusData={
      coaching_request_form_id: crfFromId,
      crf_user_id: crfId
    }
    
    DataService.getDirectData(`/crf_users/view_crf`,statusData).then(
      (res) => {
        // if(res.success){
        let crfAnswer = res;
        setCrfAnswers(crfAnswer);
        setLoading(false);
      }
    );
  };

const handleSubmit = () => {
    for (var i in answerData) {
        quesArr.push({ crf_field_id: i, value: answerData[i] })
    }
    const statusData={
        coaching_request_form_id: crfFromId,
        crf_form_section_id: sectionId,
        crf_answers: JSON.stringify(quesArr),
        crf_user_id:crfUserId || '',
        // employee_id:EmpID,
        // submitted: false,
        approval_status:(value + 1) === CoachinRequest.length ? 'Pending review by acuity' :''
      }
      let searchParams = new URLSearchParams(location.search);
      const headers = {
        "access-token": searchParams.get("access-token"),
         "client" : searchParams.get('client'),
              "uid": searchParams.get("uid"),
              "cache-control": "max-age=0, private, must-revalidate",
              "content-type": "application/json; charset=utf-8",
              // "expiry": "1606917294",
              "token-type": "Bearer"
      }
      
      axios.post(`${BASE_API_URL}/crf_answers`, statusData, {
          headers: headers
        })
        .then((res) => {
          let crfUserId = res.coaching_request_form.crf_user_id;
              setCrfUserId(crfUserId)
              if((value + 1) < CoachinRequest.length )  {
            
              setValue(value + 1)
              dispatch(showSnackbar("success", ["Success!"]));
              }
        })
        .catch((error) => {
        
        })
    //   DataService.createData(statusData, "crf_answers")
    // .then((res) => {
    //   // CrfFetch()
    //   // if (res.success) {  
    //     let crfUserId = res.coaching_request_form.crf_user_id;
    //     setCrfUserId(crfUserId)
    //     if((value + 1) < CoachinRequest.length )  {
      
    //     setValue(value + 1)
    //     dispatch(showSnackbar("success", ["Success!"]));
    //   } 
    //   dispatch(showSnackbar("success", ["Success!"]));
    //   // FetchCrfAnswer()
    // })
    // .catch((err) => {
    //   // setLoading(false);
    //   dispatch(showSnackbar("error", [["" + err.errors]]));
    // });
  };
  useEffect(() => {
    // setLoading(true);
    CrfFetch();
    // Programmes()
    // FetchCrfAnswer()
  }, []);


  function ScrollTop(props) {
    const { children } = props;
    const classes = useStyles();
    const trigger = useScrollTrigger({
      disableHysteresis: true,
      threshold: 50
    });
    const handleClick = event => {
      const anchor = (event.target.ownerDocument || document).querySelector(
        "#back-to-top-anchor"
      );

      if (anchor) {
        anchor.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    };

    return (
      <Zoom in={trigger}>
        <div onClick={handleClick} role="presentation" className={classes.root1}>
          {children}
        </div>
      </Zoom>
    );
  }
  const hidden = useHideOnScrolled();

  return (
    <div>
   
      {/* <img
        src={BannerImage}
        className={classes.bannerStyle}
        alt={BannerImage}
        width="100%"
      />
      <img 
      src={orgLogo && orgLogo.document.url}
      alt= 'logo'
      /> */}
      <div class="parent">
      <img
        src={BannerImage}
        class="image1"
        // className={classes.bannerStyle}
        alt={BannerImage}
        width="100%"
      />  
        <img 
        class="image2"
      src={orgLogo && orgLogo.document.url}
      alt= 'logo'
      />
</div>
<div className={classes.root}>
      <div className={classes.demo1} >
      <Paper elevation={3 }style={{height:'75px'}}  >
        <Tabs value={value}  onChange={handleChange} variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
>
        {CoachinRequest.length > 0 && CoachinRequest.map((item, index) => {
            return (
              <Tab
                label={item.section_name}
                {...a11yProps(index,item)}
                style={{textTransform :'initial',height:'25px'}}
              />
            );
          })}
    
        </Tabs></Paper>
      </div>
      {CoachinRequest.length > 0 && CoachinRequest.map((item, index) => {
        return (
         <TabPanel className={classes.demo2} value={value} index={index}>
          {/* <form onSubmit={handleSubmit}>  */}
            {/* {CoachinRequest.length > 0 && CoachinRequest[value].crf_field.map(
              (item) => console.log(`item.field_type`, item.field_type)
            )} */}
          <Paper style={{padding:'25px'}} elevation={1} >
              {CoachinRequest[index].crf_fields.map((row) => (
                                 <Grid
                                  container
                                  direction="row"
                                  alignItems="flex-start"
                                  style={{ marginBottom: 20 }}
                                >
                                  <Grid
                                    item
                                    xs={
                                      (row.field_name === "Description" ) ? 10 : (row.field_type === "text area" || row.field_type === "Text area") ? 12 :5                                    }
                                  >
                                    <InputLabel
                                      className={classes.labelText}
                                      style={{ marginTop: '20px',fontSize:'18px',color:'black' }}
                                    >
                                      { row.field_value === "Is approval required" ? " " : row.field_value}
                                    </InputLabel>
                                  </Grid>
                                  <Grid
                                    item
                                    style={{ paddingTop:(row.field_type === "text area" || row.field_type === "Text area") ?'20px' :''}}
                                    xs={
                                       (row.field_type === "text area" || row.field_type === "Text area") ? 9 : 4
                                    }
                                  >
                                    <Grid
                                      container
                                      direction="row"
                                      alignItems="center"
                                      style={{ marginBottom: 20 }}
                                    >
                                      <Grid item xs={12}>
                                        {(row.field_type === "text" || row.field_type === "Text") &&
                                           (
                                            // <CustomInput
                                              
                                            // //   id={crf_form_section_id}
                                            //   variant="outlined"
                                            //   placeholder =""
                                            //   parentcall={setInputState}
                                            //   value=""
                                            
                                            // />
                                        //     <TextField
                                        //     variant="outlined" 
                                        //     placeholder={row.field_value}
                                        //     autoFocus
                                        //     margin="dense"
                                        //     id={row.field_name}
                                        //     name={row.field_name}
                                            
                                        //     fullWidth
                                        //     onChange={handleChangeData(row.id)}
                                        // />
                                            <CustomInput defaultValue={row.answer} id={row.id} variant="outlined" placeholder={row.field_value} parentcall={setInputState}  />

                                          )}
                                                   {(row.field_type === "text area" ||  row.field_type === "Text area") 
                                          && (
                                            <CustomInput
                                              
                                              multiline
                                              rows="4"
                                              id={row.id}
                                              defaultValue={row.answer}
                                            //   id={crf_answers}
                                              variant="outlined"
                                              parentcall={setInputState}
                                             
                                            />
                                          )}
                                        {(row.field_type === "dropdown" || row.field_type === "Drop down") && (
                                                        //   <CustomSelect
                                                        //   id="field_type"
                                                        //   displayEmpty
                                                        //   variant="outlined"
                                                        //   labelText="select field type"
                                                        //   // defaultValue={ row.dropdown_values}
                                                        //   // itemArr={row.dropdown_values}
                                                        //   parentcall={setQuestionChangeState}
                                                      
                                                        // />
                                          <Select
                                            helperText="Please select Location"
                                            variant="outlined"
                                            id={row.id}
                                            defaultValue={row.answer}
                                            onChange={(e)=>setQuestionChangeState(e.target.value,row.id)}
                                            // onChange={setQuestionChangeState}
                                            style={{ width: "100%" }}
                                            inputProps={{
                                              id: "outlined-age-native-simple",
                                            }}
                                          >
                                          {row.field_value === 'Programme Name' ? CoachinRates.map(base=><MenuItem key={base.id} value={base.name}>
                                            {base.name}
                                        </MenuItem>) : row.dropdown_values && row.dropdown_values.map(base=><MenuItem key={base} value={base}>
                                            {base}
                                        </MenuItem>)}
                                          </Select>
                                        )}
                                        {/* {row.field_type === 'radio_button' &&
                                                     ( <React.Fragment>
                                                                             <Grid item xs={12}>
                                                       <RadioGroup row aria-label="position" name="rate_type"   >
                                                 <FormControlLabel
                                                   value="external"
                                                   control={<Radio color="primary" />}
                                                   label="Yes"
                                                   labelPlacement="end" 
                                                 />
                                                 <FormControlLabel
                                                   value="internal"
                                                   control={<Radio color="primary" />}
                                                   label="No"
                                                   labelPlacement="end"
                                                 />
                                                 </RadioGroup></Grid>
                                                 <Grid item xs={1}>
                                                 <Button  disableElevation 
                                                     variant="contained"
                                                     style={{fontSize:'9px',}}
                                                     color="primary"
                                                     onClick={() => {
                                                       setAction("create");
                                                     }}
                                                   >
                                                    Save
                                                   </Button></Grid></React.Fragment> )
                                        } */}
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  <Grid item xs={ 0}></Grid>
                                  <Grid item xs={2}>
                                  
                               
                                  </Grid>
                               {row.field_value === "Is approval required" && <React.Fragment> <Grid item xs={12}>      
              <InputLabel
                                      className={classes.labelText}
                                      style={{ marginTop: 20 }}
                                    >
                                      Is approval required

                                    </InputLabel></Grid>
                                    <Grid item xs={12}> 
              <FormControl component="fieldset">
                                    <RadioGroup row aria-label="item" defaultValue={radioValue } name="approval_required" onChange={handleradioChange}>
                                        <FormControlLabel value="true" control={<Radio />} label="Yes" />
                                        <FormControlLabel value="false" control={<Radio />} label="No" />
                                    </RadioGroup>
                                </FormControl></Grid>
                                <Grid item xs={1}>
                                <Button
                                                     variant="contained"
                                                     style={{fontSize:'13px',}}
                                                     color="primary"
                                                     onClick={() => {
                                                      handleUpdate()
                                                     }}
                                                   >
                                                    Save
                                                   </Button></Grid></React.Fragment> }
                                </Grid>
                 
                             
                              
                              ))}  
                        <Grid container direction="row" alignItems="flex-start">
            {/* <Grid item xs={10}></Grid>
            <Grid item xs={2}>
            <ScrollTop>
          <Fab style={{ width: "40px", height: "20px" }} aria-label="scroll back to top">
              <Button
                disableElevation
                variant="contained"
                color="primary"
                className={classes.btnSearch}
                onClick={handleSubmit}
              >
                Submit
              </Button>
              </Fab>
        </ScrollTop> 
            </Grid>
          </Grid> */}
          <Grid item xs={10}></Grid>
{!hidden && <Grid item xs={2} style={{ height: "100%", overflow: "hidden" }} >
        <Button disableElevation variant="contained" color="primary" className={classes.btnSearch}
          onClick={handleSubmit}
        >
          { "Submit"}
        </Button>
      </Grid>}  
      <Grid item xs={2}>

        <ScrollTop>
          <Fab style={{ width: "40px", height: "20px" }} aria-label="scroll back to top">
            <Button disableElevation variant="contained" color="primary" className={classes.btnSearch}
              onClick={handleSubmit}
            >
              { "Submit"}
            </Button>        </Fab>
        </ScrollTop> 
        </Grid>
        </Grid>
                 </Paper>
          </TabPanel>  
        );
      })}
    </div>
    </div>
  );
}


